import React from 'react';

export default function MTMenuButton() {
  return (
    <button
      type="button"
      className="fixed bottom-5 right-5 z-50 text-xs font-medium tracking-[0.3em] text-gray-500 transition-colors duration-200 hover:text-gray-300"
      aria-label="MT menu"
    >
      MT
    </button>
  );
}
